<modal #EmbedBook_Modals class="embed-book-modal">
  <div class="book-appointment">
    <i class="fa fa-times fa-lg close-btn-book float-right p-2" (click)="EmbedBook_Modals.close()" aria-hidden="true"></i>
    <embed-modals-appointment-book (callEventBookEmitter)="handlecallEventBookEmitter()"></embed-modals-appointment-book>
  </div>
</modal>
